/**
 * @generated SignedSource<<3d3cdba86576093fc4788b6bd0ccc7f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AIGrammarReportMutation$variables = {
  id: string;
};
export type AIGrammarReportMutation$data = {
  readonly reportGrammar: boolean | null;
};
export type AIGrammarReportMutation = {
  response: AIGrammarReportMutation$data;
  variables: AIGrammarReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "reportGrammar",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AIGrammarReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AIGrammarReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3b9326acebbed316065cfbb51537850",
    "id": null,
    "metadata": {},
    "name": "AIGrammarReportMutation",
    "operationKind": "mutation",
    "text": "mutation AIGrammarReportMutation(\n  $id: String!\n) {\n  reportGrammar(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "11bb9508c1884247d2ce01fafc08a767";

export default node;
